import { Shimmer, ShimmerElementType, Stack } from "@fluentui/react";
import { Card, Text, tokens } from "@fluentui/react-components";
import { Image } from "@fluentui/react/lib/Image";
import DefenderImage from "../../../../../images//defender.png";
import EntraImage from "../../../../../images//entraa.png";
import IntuneImage from "../../../../../images//Intune.jpg";
import PrivaImage from "../../../../../images//priva.png";
import PurviewImage from "../../../../../images//purview.png";
import SentinelImage from "../../../../../images//sentinel.png";
import Copilot365Image from "../../../../../images/copilot365.jpg";
import { CustomToggleButtonGroup } from "../../../../../SharedComponents/CustomToggleButtonGroup";
import { useGetProductExploreDataQuery } from "../../../../../slices/ExploreProducts.slice";
import { PRODUCT_VIEW_STYLES as styles } from "../../../Common/ProductView.styles";

export const ProductFamilySelector = ({
  selectedFamily,
  setSelectedFamily
}: {
  selectedFamily: string;
  setSelectedFamily: (family: string) => void;
}) => {
  const { data, isError, isLoading } = useGetProductExploreDataQuery(null);

  const familyImages: { [key: string]: string } = {
    "Cloud Security": Copilot365Image,
    "Microsoft Defender": DefenderImage,
    "Microsoft Entra": EntraImage,
    "Microsoft Intune": IntuneImage,
    "Microsoft Priva": PrivaImage,
    "Microsoft Purview": PurviewImage,
    "Microsoft Sentinel": SentinelImage,
    "Security Copilot": Copilot365Image,
    "Microsoft Defender for Cloud": DefenderImage
  };

  const productFamilyToggleButtons = (
    <CustomToggleButtonGroup
      items={Array.from(new Set(data?.map(({ productFamily }: any) => productFamily)))}
      selected={selectedFamily}
      setSelected={setSelectedFamily}
      stackProps={{
        styles: styles.PRODUCT_LIST.CSS_STYLES.familyToggleButtons
      }}
    />
  );

  const familyLogoWithText = (
    <Stack horizontal tokens={{ childrenGap: 6 }} styles={styles.PRODUCT_LIST.CSS_STYLES.familyLogoWithTextStack}>
      <Image
        alt={`${selectedFamily} Logo`}
        height={35}
        width={35}
        src={familyImages[selectedFamily]}
        styles={styles.PRODUCT_LIST.CSS_STYLES.familyLogoImage}
      />
      <Text style={styles.PRODUCT_LIST.CSS_STYLES.currentSelectedFamily}>{selectedFamily}</Text>
    </Stack>
  );

  if (isLoading) {
    return (
      <div className={styles.PRODUCT_LIST.CLASS_NAMES.selectedFamilyShimmerContainer}>
        <Stack horizontal wrap styles={styles.PRODUCT_LIST.CSS_STYLES.currentSelectedFamilyShimmerStack}>
          {Array.from({ length: 6 }).map(() => (
            <Shimmer
              key={`loading-${crypto.randomUUID()}`}
              shimmerElements={[{ type: ShimmerElementType.line, height: 32 }]}
              styles={styles.PRODUCT_LIST.CSS_STYLES.familyToggleButtonsShimmer}
            />
          ))}
        </Stack>
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: 6 }}
          styles={{ root: { marginBlockEnd: tokens.spacingVerticalL } }}
        >
          <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 35, width: 35 }]} />
          <Shimmer
            shimmerElements={[{ type: ShimmerElementType.line, height: 20 }]}
            styles={styles.PRODUCT_LIST.CSS_STYLES.exploreMoreLinkShimmer}
          />
        </Stack>
      </div>
    );
  }

  if (isError) return <Card style={{ margin: tokens.spacingVerticalL }}>Error loading data</Card>;

  return (
    <div style={{ margin: tokens.spacingVerticalL }}>
      {productFamilyToggleButtons}
      {familyLogoWithText}
    </div>
  );
};
